import { StatusBadge } from "@/components/admin/StatusBadge";
import type { ProgrammeConversion } from "@/types";

/** Marks a Cohort that sells the Dominion Free product (KC-495). */
export function FreemiumBadge() {
  return (
    <span title="Sells Dominion Free">
      <StatusBadge tone="info">Freemium</StatusBadge>
    </span>
  );
}

/** Marks a Cohort that sells The Desk (KC-507). */
export function DeskBadge() {
  return (
    <span title="Sells The Desk">
      <StatusBadge tone="info">The Desk</StatusBadge>
    </span>
  );
}

/** "N of M converted": Participants of a freemium Cohort who later enrolled in a paid one (KC-499). */
export function ConversionCount({ conversion }: { conversion: ProgrammeConversion }) {
  return (
    <span title="Participants who later enrolled in a paid cohort">
      {conversion.converted} of {conversion.participants} converted
    </span>
  );
}
